import { memo } from 'react'
import { isEqual } from 'lodash'
import EventManagementContainer from 'app/containers/EventManagement'
import { PageTitle } from 'app/components/common/PageTitle'
import { useTranslation } from 'react-i18next'
import R from 'app/assets/R'

const EventManagementCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.event_management)}</PageTitle>
      <EventManagementContainer />
    </>
  )
}
export const EventManagementPage = memo(EventManagementCpn, isEqual)
